module.exports = __webpack_public_path__ + "img/12_90.025abeca.png";